import { ListItem, Box, LinearProgress, Button } from '@mui/material'
import { ShoppingCartOutlined as ShoppingCart } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import type { OpenAPIResponseData } from '../../api/api-switcher'
import type { UserAPI } from '../../api/api-switcher'
import { byte2str, isStorageDisplayAsPhotoCount } from '../../utils/functions'

type Me = OpenAPIResponseData<ReturnType<typeof UserAPI.getMe>>

const StorageBar: React.FC<{me: Me}> = ({me}) => {
  const { t } = useTranslation()

  const { used, total, percent } = isStorageDisplayAsPhotoCount(me.storage_count_files)
    ? {
        used: me.storage_used_count_files,
        total: t('general.photos_num', {num: me.storage_count_files}),
        percent: (me.storage_used_count_files / me.storage_count_files) * 100
      }
    : {
        used: byte2str(me.storage_used_bytes),
        total: byte2str(me.storage_size_bytes),
        percent: (me.storage_used_bytes / me.storage_size_bytes) * 100
      }

  return <ListItem>
    <Box ml={2}>
      <Box sx={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
        <Box>
          {t('general.storage')}
        </Box>
        <Box>
          <span style={{fontWeight: 'bold'}}>
            {used}
          </span>
          {' / '}
          {total}
        </Box>
      </Box>
      <Box sx={{width: '100%', margin: '6px 0'}}>
        <LinearProgress
          color={percent < 90 ? 'primary' : 'error'}
          variant='determinate'
          sx={{
            height: 12, borderRadius: 6, backgroundColor: 'gray_b.main',
            '& .MuiLinearProgress-bar': { borderRadius: 6 }
          }}
          value={percent}
        />
      </Box>
      {FEATURE_PLAN && !['premium_monthly', 'premium_annual'].includes(me.plan_id) && (
        <Button
          component={Link}
          to='/plan'
          variant='contained'
          color='gray_b'
          size='small'
          startIcon={<ShoppingCart />}
          sx={{ mt: 1, width: '100%' }}
        >
          {t('general.upgrade_plan')}
        </Button>
      )}
    </Box>
  </ListItem>
}

export default StorageBar
